// extracted by mini-css-extract-plugin
export var brand = "_3m-9";
export var compact = "_3m-6";
export var extraSmall = "_3m-7";
export var icon = "_3m-0";
export var large = "_3m-4";
export var light = "_3m-1";
export var medium = "_3m-5";
export var outline = "_3m-b";
export var primaryDark = "_3m-a";
export var primaryLight = "_3m-8";
export var primaryModern = "_3m-c";
export var success = "_3m-2";
export var successSolid = "_3m-3";